import React from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '@dashboard/components/pages/QueryListPage/PageWrapper/Header';
import { createTableComponent } from '@dashboard/components/pages/QueryListPage/TableList/WpDataGrid';
import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { useCreateSamplePlatformMutation } from '@dashboard/generated/wp/authentication';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Link,
  Paper,
  Skeleton,
  Typography,
} from '@mui/material';

import foundersImgSrc from './founders.png';

function renderCell() {
  return <Skeleton width="100%" animation={false} />;
}

const SkeletonTable = createTableComponent<{ id: string }>({
  emptyResults: <></>,
  columns: [
    { headerName: 'Event', renderCell, minWidth: 128, maxWidth: 128 },
    {
      headerName: 'Timestamp',
      renderCell,
      minWidth: 176,
      maxWidth: 192,
    },
    {
      headerName: 'Template',
      renderCell,
    },
    {
      headerName: 'Recipient',
      renderCell,
    },
    {
      headerName: 'From',
      renderCell,
    },
    {
      headerName: 'ID',
      renderCell,
      minWidth: 128,
      maxWidth: 200,
    },
  ],
});

const PAGINATION = {
  count: 3,
  limit: 50,
  page: 1,
};
const NODES = [{ id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }];

export default function FoundersLetter() {
  const [createSamplePlatform, { loading }] = useCreateSamplePlatformMutation();
  const navigate = useNavigate();
  const onClick = async () => {
    if (loading) {
      return;
    }
    const { data } = await createSamplePlatform();
    const id = data?.createSamplePlatform.id;
    if (id) {
      navigate(`/o/${id}`);
    }
  };

  return (
    <>
      <Paper>
        <Header title="Activity" pagination={PAGINATION} />
        <SkeletonTable nodes={NODES} />
      </Paper>
      <Dialog open onClose={onClick}>
        <DialogContent sx={{ '.MuiTypography-paragraph': { fontSize: MARKETBASE_THEME.typography.pxToRem(16) } }}>
          <Box sx={{ mt: 5, mb: 2, textAlign: 'center' }}>
            <Divider />
            <Box component="img" src={foundersImgSrc} alt="Plus icon" sx={{ maxHeight: 48, mt: -3 }} />
          </Box>
          <Typography paragraph sx={{ mb: 4 }}>
            Welcome 👋
          </Typography>
          <Typography paragraph>We&rsquo;re Jordan and Carlos, the co-founders of Waypoint.</Typography>
          <Typography paragraph>
            With Waypoint, product emails are effortless. Developers can focus on sending data while the rest of the
            team handles templates and monitoring with tools on Waypoint.
          </Typography>
          <Typography paragraph>
            After 20+ years of building software, we know how frustrating email collaboration can be. We built Waypoint
            to fix that &mdash; and we hope your team loves it as much as we do.
          </Typography>
          <Typography paragraph>
            If you ever need help, email us at{' '}
            <Link href="mailto: support@usewaypoint.com">support@usewaypoint.com</Link>. We&rsquo;re always happy to
            help.
          </Typography>
          <Typography paragraph sx={{ mt: 4 }}>
            &mdash; Jordan &amp; Carlos
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} fullWidth variant="contained" size="large" onClick={onClick}>
            Start exploring Waypoint
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
